export default {
  state: {
    finappSrc: '',
    iframeWidth: '1000px',
    tipsVisible: false,
    dataChanged: false,
    showToastMessage: false,
    showFontUploadDialog: false,
    showCreateLabelDialog: false,
    toastMessage: '',
    mediaClass: '',
    finappList: [],
    finappContainersList: [],
    dashboardFinappList: [],
    cobrandOptedfinapps: [],
    cobrandDraftData: {},
    previewedData: {},
    selectedCobrand: {
      selectedCobrandName: '',
      selectedCobrandId: '',
      selectedAppId: '',
      selectedAppName: '',
      selectedEnvironment: ''
    }
  },
  mutations: {
    updateFont (state, payload) {
      if (state.cobrandDraftData.font) {
        state.cobrandDraftData.font['default'] = payload;
      }
    }
  },
  actions: {}
}